document.addEventListener('DOMContentLoaded', function () {
  const container = document.querySelector('.yoj-carousel-container');
  const slides = document.querySelector('.yoj-carousel-slides');
  const navigation = document.querySelector('.yoj-carousel-navigation');
  const prevButton = document.querySelector('.yoj-carousel-prev');
  const nextButton = document.querySelector('.yoj-carousel-next');
  let currentIndex = 0;

  function showSlide(index) {
    const translateValue = -index * 100 + '%';
    slides.style.transform = 'translateX(' + translateValue + ')';
  }

  function nextSlide() {
    currentIndex = (currentIndex + 1) % slides.children.length;
    showSlide(currentIndex);
    updateNavigation();
  }

  function prevSlide() {
    currentIndex = (currentIndex - 1 + slides.children.length) % slides.children.length;
    showSlide(currentIndex);
    updateNavigation();
  }

  function updateNavigation() {
    navigation.innerHTML = '';

    const numSlides = slides.children.length;
  
    // Hide navigation buttons if there's only one slide
    if (numSlides <= 1) {
      prevButton.style.display = 'none';
      nextButton.style.display = 'none';
      return;
    } else {
      prevButton.style.display = 'block';
      nextButton.style.display = 'block';
    }
    
    for (let i = 0; i < slides.children.length; i++) {
      const button = document.createElement('button');
      button.innerText = i + 1;
      button.addEventListener('click', function () {
        currentIndex = i;
        showSlide(currentIndex);
        updateNavigation();
      });
	  if (i === currentIndex) {
        button.classList.add('active'); // Add 'active' class to the selected button
      }
      navigation.appendChild(button);
    }
  }

  // Add event listeners to the buttons
  prevButton.addEventListener('click', prevSlide);
  nextButton.addEventListener('click', nextSlide);

// Swipe gesture
  container.addEventListener('touchstart', function (e) {
    startX = e.touches[0].clientX;
  });

  container.addEventListener('touchmove', function (e) {
    endX = e.touches[0].clientX;
    const deltaX = endX - startX;

    if (Math.abs(deltaX) > 20) {
      e.preventDefault(); // Prevent vertical scrolling
    }    
  });

  container.addEventListener('touchend', function () {
    const threshold = 200; // Adjust
    const deltaX = endX - startX;

    if (deltaX > threshold) {
      prevSlide();
    } else if (deltaX < -threshold) {
      nextSlide();
    }
  });


  // Initial update
  updateNavigation();
});